/**
 * @generated SignedSource<<b8deb792305846630ec54bb38eaf6410>>
 * @relayHash c12ecc32f67b9088f404b499d443811d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f611286cc367935ccd5bf8f788e8f6f10ec73ad24a3a2b568b6b7145760c0d3f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f611286cc367935ccd5bf8f788e8f6f10ec73ad24a3a2b568b6b7145760c0d3f",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
